<template>
    <div class="root">
        <v-subheader class="pl-0 title" v-if="$store.state.zones.length">
            {{$vuetify.t('$vuetify.zone.chooseZone')}}

            <v-btn
                absolute small dark
                fab right color="primary"
                v-if="selectedZones.length"
                @click="confirmZones"
            >
                <v-icon>done</v-icon>
            </v-btn>
        </v-subheader>

        <v-checkbox
            v-for="zone in $store.state.zones"
            :key="zone.id"
            :value="zone.id"
            :label="zone.name"
            hide-details
            v-model="selectedZones"
        />

        <v-btn
            color="primary"
            block
            class="mt-5"
            v-if="selectedZones.length"
            @click="confirmZones"
        >{{ $vuetify.t('$vuetify.zone.confirm') }}</v-btn>

        <!--<v-subheader class="pl-0 mt-3 title" v-if="$store.state.checkpoints.length">-->
        <!--    {{$vuetify.t('$vuetify.checkpoint.chooseCheckpoint')}}-->
        <!--</v-subheader>-->

        <!--<v-btn-->
        <!--    color="secondary"-->
        <!--    block-->
        <!--    class="mt-0"-->
        <!--    v-for="checkpoint in $store.state.checkpoints"-->
        <!--    @click="selectCheckpoint(checkpoint.id)"-->
        <!--    style="text-transform: none;"-->
        <!--&gt;-->
        <!--    {{ checkpoint.name }} ({{ ticketsetsCount(checkpoint.ticketsets.length) }})-->
        <!--</v-btn>-->

        <v-subheader class="pl-0 title pb-0 mt-4">
            {{$vuetify.t('$vuetify.event.chooseEvent')}}

            <v-btn
                absolute small dark
                fab right color="primary"
                v-if="selectedEvents.length"
                @click="confirmEvents"
            >
                <v-icon>done</v-icon>
            </v-btn>
        </v-subheader>

        <v-checkbox
            v-for="event in getEventsUpcomming"
            :key="event.id"
            :value="event.id"
            :label="`${event.name} (${(event.startAt === null && event.endAt === null) ? 'neomezená':''}${event.endAt ? formatDate(event.startAt) : ''}${event.endAt ? ' - '+formatDate(event.endAt):''})`"
            hide-details
            v-model="selectedEvents"
        />

        <v-subheader class="pl-0 title pb-0 mt-4">
            {{$vuetify.t('$vuetify.event.chooseEventPast')}}
            ({{ olderEventsLimitText }})
            <a v-if="!pastShown" style="font-size: 75%" class="ml-3" @click="pastShown = !pastShown">
                &CirclePlus; {{$vuetify.t('$vuetify.event.showPast')}}
            </a>
        </v-subheader>

        <div v-if="pastShown">
            <v-checkbox
                v-for="event in getEventsPast"
                :key="event.id"
                :value="event.id"
                :label="`${event.name} (${formatDate(event.startAt)})`"
                hide-details
                v-model="selectedEvents"
            />
        </div>

        <v-btn
            color="primary"
            block
            class="mt-5"
            v-if="selectedEvents.length"
            @click="confirmEvents"
        >{{ $vuetify.t('$vuetify.event.confirm') }}</v-btn>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        name: 'events',

        data() {
            return {
                selectedEvents: [],
                selectedZones: [],
                pastShown: false
            }
        },

        components: {},

        methods: {
            confirmEvents() {
                this.$store.commit('setActiveEvents', this.selectedEvents)
                this.$store.commit('setActiveCheckpoint', null)
                this.$store.commit('setLastZones', [])
                this.$store.commit('setActiveZones', [])
                this.$router.push({name:'ticketsets'})
            },

            // selectCheckpoint(id) {
            //     this.$store.commit('setActiveEvents', [])
            //     this.$store.commit('setActiveCheckpoint', id)
            //     this.$store.commit('setLastZones', [])
            //     this.$store.commit('setActiveZones', [])
            //     this.$router.push({name:'ticketsets'})
            // },

            confirmZones() {
                this.$store.commit('setLastZones', [])
                this.$store.commit('setActiveEvents', [])
                this.$store.commit('setActiveCheckpoint', null)
                this.$store.commit('setActiveZones', this.selectedZones.map(id => parseInt(id)))
                this.$router.push({name:'scanner'})
            },

            // ticketsetsCount(count) {
            //     if (count === 0) {
            //         return this.$vuetify.t('$vuetify.checkpoint.set0')
            //     } else if (count === 1) {
            //         return this.$vuetify.t('$vuetify.checkpoint.set1')
            //     } else if (count === 2 || count === 3 || count === 4) {
            //         return this.$vuetify.t('$vuetify.checkpoint.set2', count)
            //     } else {
            //         return this.$vuetify.t('$vuetify.checkpoint.set5', count)
            //     }
            // },

            formatDate(date) {
                return moment(date).format('D.M.YYYY')
            }
        },

        computed: {
            getEventsUpcomming() {
                let now = moment().add(-1, 'days')
                return this.$store.state.events.filter(event => {
                    return moment(event.endAt ? event.endAt : event.startAt).isSameOrAfter(now) ||
                        (event.startAt === null && event.endAt === null)
                }).sort((a, b) => {
                    return moment(a.startAt).isAfter(moment(b.startAt)) ? 1 : -1
                })
            },
            getEventsPast() {
                let now = moment().add(-1, 'days')
                return this.$store.state.events.filter(event => {
                    return moment(event.endAt ? event.endAt : event.startAt).isBefore(now)
                }).sort((a, b) => {
                    return moment(a.startAt).isAfter(moment(b.startAt)) ? -1 : 0
                })
            },

            olderEventsLimitText() {
                switch(this.$store.state.settings.olderEvents) {
                    case 7: return this.$vuetify.t('$vuetify.settings.olderEventsWeek');
                    case 30: return this.$vuetify.t('$vuetify.settings.olderEventsMonth');
                    case 90: return this.$vuetify.t('$vuetify.settings.olderEvents3Month');
                    case 180: return this.$vuetify.t('$vuetify.settings.olderEvents6Month');
                    case 365: return this.$vuetify.t('$vuetify.settings.olderEventsYear');
                    default:
                        return this.$vuetify.t('$vuetify.settings.olderEventsAllList');
                }
            }
        },

        created() {
            this.$store.commit('setActiveEvents', [])
            this.$store.commit('clearTickets')
            this.$store.dispatch('loadEvents', this.$store.state.settings.olderEvents)
            // this.$store.dispatch('loadCheckpoints')
            this.$store.dispatch('loadZones')
        }
    }
</script>

<style lang="scss" scoped>
</style>
